module.exports = __webpack_public_path__ + "static/media/group-tool.a4cf0b98.svg";